export default __webpack_public_path__ + "static/media/testimonial-2.aa991a08.png";